import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormArray, FormControl, Validators, AbstractControl } from '@angular/forms';
import { log } from 'console';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { ILineItemData, IPurchaseOrder_New } from 'src/app/modules/po-buyer/models';
import { PoBuyerService } from 'src/app/modules/po-buyer/services/po-buyer.service';
import { SupplierHelperService } from 'src/app/modules/supplier/services/supplier-helper.service';

@Component({
  selector: 'app-po-confirmation-response',
  templateUrl: './po-confirmation-response.component.html',
  styleUrls: ['./po-confirmation-response.component.scss']
})
export class PoConfirmationResponseComponent implements OnInit {

  public title !: string;
  public purchaseOrders : Array<IPurchaseOrder_New> = [];

  public onClose = new Subject<boolean>();

  // form group
  public feedbackForm !: FormGroup;
  
  constructor(
    public bsModalRef: BsModalRef,
    private _poBuyerService : PoBuyerService,
    private _toastr : ToastrService,
    private _helperService : SupplierHelperService,
    private _fb : FormBuilder) { }

  ngOnInit(): void {
    this.purchaseOrders.length && this.prepareForm();
    console.log(this.purchaseOrders);
  }

  public onModalClose(): void {
    this.bsModalRef.hide();
  }

  public closeModal(data ?: any) {
    this.onClose.next(data);
    this.bsModalRef.hide();
  }

  getFormArrayName(prop: string): any {
    const formArr =  this.feedbackForm.controls[prop] as FormGroup;
    return formArr.controls
  }

  private prepareForm() : void {
    this.feedbackForm = this._helperService.preparePOConfirmationFeedbackForm(this.purchaseOrders);
    console.log(this.feedbackForm)
  }

  public updateInfo() : void {
    console.log(this.purchaseOrders)
    console.log("this.feedbackForm.value:",this.feedbackForm.value)
    let body: IPurchaseOrder_New[] = [];
    Object.keys(this.feedbackForm.controls).forEach((element:any)=>{
      console.log(this.feedbackForm.value.element);
      this.feedbackForm.value[element].forEach((value:any)=>{
        let req = {  "po_count": this.purchaseOrders.filter((po:IPurchaseOrder_New)=>po.pr_number == element)[0].po_count,
        "pr_number": element,
        "po_data": [
            {...{
               "po_number": value.po_number,
                "supplier_acknowledgment_status": value.supplier_acknowledgment_status,
                "vendor_remarks": value.vendor_remarks,},...value}]
            }
        body.push(req)
      })
      // body.push(this.feedbackForm.value[element])
    })
    console.log("this.feedbackForm.valuessssss:",{data:body})
    this._poBuyerService.updatePOConfirmation({data:body}).subscribe((res) => {
      this._toastr.success(res.data);
      this.closeModal(true);
    })
  }

  public setConfirmedQuantity(prop: string, j : number, k: number) : void {
    const formArrayControls = this.getFormArrayName(prop);
    const confirmedQuantityFormGroup = formArrayControls[j].controls['line_item_data'].controls[k].controls['confirmed_quantity'];

    const actualQuantity= formArrayControls[j].value.line_item_data[k].quantity;
    if (formArrayControls[j].value.line_item_data[k].indicator === 'Full') {
      confirmedQuantityFormGroup.patchValue(actualQuantity);
      confirmedQuantityFormGroup.disable();

      let removeFromGroup = true;
      while (removeFromGroup) {
        const index = formArrayControls[j].value.line_item_data.findIndex((line_item_data: ILineItemData ) => line_item_data.new_line_partial_data === true);
        if(index > -1) {
          (formArrayControls[j].controls["line_item_data"] as FormArray).removeAt(index);
        } else {
          removeFromGroup = false;
        }
      }
    } else {
      let sumOfConfirmedQuantities: number = 0;
      formArrayControls[j].controls['line_item_data'].controls.forEach((line_item_data: FormGroup) => {
        sumOfConfirmedQuantities = +line_item_data.controls['confirmed_quantity'].value + sumOfConfirmedQuantities;
      })
      formArrayControls[j].controls['line_item_data'].controls.forEach((line_item_data: FormGroup) => {
        line_item_data.controls['confirmed_quantity'].setValidators([Validators.required,this.ConfQtyValidation(actualQuantity,sumOfConfirmedQuantities,formArrayControls[j].length)]);
        line_item_data.controls['confirmed_quantity'].updateValueAndValidity();
      })
      confirmedQuantityFormGroup.patchValue("");
      confirmedQuantityFormGroup.enable();
    }
  }

  public createLineItemData(prop: string, j : number, k: number) : void {
    const formArrayControls = this.getFormArrayName(prop);
    
    let hasEmptyRow:boolean = false;
    let emptyRowIndex: number = 0;
    const actualQuantity= formArrayControls[j].value.line_item_data[k].quantity;
    let sumOfConfirmedQuantities: number = 0;
    
    formArrayControls[j].controls['line_item_data'].controls.forEach((line_item_data: FormGroup,index:number) => {
      sumOfConfirmedQuantities = +line_item_data.controls['confirmed_quantity'].value + sumOfConfirmedQuantities;
      hasEmptyRow = !line_item_data.controls['confirmed_quantity'].value;
      hasEmptyRow?emptyRowIndex = index:'';
    });
    formArrayControls[j].controls['line_item_data'].controls.forEach((line_item_data: FormGroup) => {
      line_item_data.controls['confirmed_quantity'].setValidators([Validators.required,this.ConfQtyValidation(actualQuantity,sumOfConfirmedQuantities,formArrayControls[j].length)]);
      line_item_data.controls['confirmed_quantity'].updateValueAndValidity();
    });
    // Need more validations
    if (formArrayControls[j].value.line_item_data[k].indicator !== 'Full' && sumOfConfirmedQuantities < actualQuantity && !hasEmptyRow) {
      const line_item_data0 = formArrayControls[j].value.line_item_data[0];
      
        const newlineItemNestedForm : FormGroup =  this._fb.group({});
        Object.keys(line_item_data0).forEach((key : string) => {
          if(key === "confirmed_quantity"){
            newlineItemNestedForm.addControl(key, new FormControl("", []));
          } else {
            newlineItemNestedForm.addControl(key, new FormControl(line_item_data0[key], []));
          }
        });
        newlineItemNestedForm.addControl('new_line_partial_data', new FormControl(true, []));
        newlineItemNestedForm.controls['indicator'].setValue("Partial");
        // newlineItemNestedForm.controls['indicator'].disable();
       (formArrayControls[j].controls["line_item_data"] as FormArray).push(newlineItemNestedForm);
    } else if(sumOfConfirmedQuantities == actualQuantity && hasEmptyRow){
      (formArrayControls[j].controls["line_item_data"] as FormArray).removeAt(emptyRowIndex);
    }
  } 

  public ConfQtyValidation(totalQty: number, sumOfConfirmedQuantities:number, arraylength:number) {
    return (control: AbstractControl): { [key: string]: any } | undefined | null | any => {
      console.log(this.feedbackForm)
      if (control.value == 0 || control.value > totalQty)
        return { "ValidQuantity": true };
      if ((arraylength && (((totalQty - sumOfConfirmedQuantities) < control.value) || (sumOfConfirmedQuantities + control.value > totalQty))) || sumOfConfirmedQuantities > totalQty) {
        return { "overCount": true}
      }
      return null;
    }
  }

}
